/* JAPANIME.IT — Phase 37 Judge.me readable auto carousel. */
(() => {
  const SELECTOR = '.jp-home-reviews .jdgm-carousel';
  const AUTOPLAY_DELAY = 6500;
  const RESUME_DELAY = 9000;
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const italian = document.documentElement.lang.toLowerCase().startsWith('it');
  let reviewBodyId = 0;

  const setReviewExpanded = (card, expanded) => {
    const button = card.querySelector('.jp-review-toggle');
    if (!button) return;
    card.classList.toggle('jp-review-expanded', expanded);
    button.setAttribute('aria-expanded', String(expanded));
    button.textContent = expanded
      ? (italian ? 'Riduci' : 'Show less')
      : (italian ? 'Leggi tutto' : 'Read more');
  };

  const syncReviewToggle = (card) => {
    const button = card.querySelector('.jp-review-toggle');
    const body = card.querySelector('.jdgm-carousel-item__review-body');
    const title = card.querySelector('.jdgm-carousel-item__review-title');
    if (!button || !body || card.classList.contains('jp-review-expanded')) return;
    const clipped = body.scrollHeight > body.clientHeight + 2 || (title && title.scrollHeight > title.clientHeight + 2);
    button.hidden = !clipped;
  };

  const setupReviewToggle = (card, carousel) => {
    const body = card.querySelector('.jdgm-carousel-item__review-body');
    if (!body) return;
    let button = card.querySelector('.jp-review-toggle');
    if (!button) {
      if (!body.id) body.id = `jp-review-body-${++reviewBodyId}`;
      button = document.createElement('button');
      button.type = 'button';
      button.className = 'jp-review-toggle';
      button.hidden = true;
      button.setAttribute('aria-controls', body.id);
      button.setAttribute('aria-expanded', 'false');
      button.textContent = italian ? 'Leggi tutto' : 'Read more';
      body.insertAdjacentElement('afterend', button);
      button.addEventListener('click', () => {
        const expand = !card.classList.contains('jp-review-expanded');
        if (expand) carousel.querySelectorAll('.jdgm-carousel-item.jp-review-expanded').forEach((other) => setReviewExpanded(other, false));
        setReviewExpanded(card, expand);
        if (!expand) requestAnimationFrame(() => syncReviewToggle(card));
      });
    }
    requestAnimationFrame(() => syncReviewToggle(card));
  };

  const setupCarousel = (carousel) => {
    const track = carousel.querySelector('.jdgm-carousel__item-wrapper');
    const cards = [...(track?.querySelectorAll('.jdgm-carousel-item') || [])];
    cards.forEach((card) => setupReviewToggle(card, carousel));
    if (!track || cards.length < 2 || track.dataset.jpAutoCarousel === 'true') return;

    track.dataset.jpAutoCarousel = 'true';
    let autoplayTimer = 0;
    let resumeTimer = 0;
    let interactionPaused = false;

    const cardStep = () => {
      const card = cards.find((item) => item.offsetWidth > 0);
      if (!card) return track.clientWidth;
      const styles = getComputedStyle(track);
      return card.getBoundingClientRect().width + (Number.parseFloat(styles.columnGap || styles.gap) || 0);
    };

    const lastStart = () => Math.max(0, track.scrollWidth - track.clientWidth);
    const scrollToPosition = (left) => {
      track.scrollTo({ left: Math.max(0, Math.min(left, lastStart())), behavior: reducedMotion.matches ? 'auto' : 'smooth' });
    };

    const move = (direction) => {
      const end = lastStart();
      if (end <= 2) return;
      track.querySelectorAll('.jdgm-carousel-item.jp-review-expanded').forEach((card) => setReviewExpanded(card, false));
      if (direction > 0 && track.scrollLeft >= end - 4) scrollToPosition(0);
      else if (direction < 0 && track.scrollLeft <= 4) scrollToPosition(end);
      else scrollToPosition(track.scrollLeft + cardStep() * direction);
    };

    const stopAutoplay = () => {
      window.clearInterval(autoplayTimer);
      autoplayTimer = 0;
    };

    const startAutoplay = () => {
      stopAutoplay();
      if (reducedMotion.matches || interactionPaused || document.hidden || track.querySelector('.jp-review-expanded') || lastStart() <= 2) return;
      autoplayTimer = window.setInterval(() => move(1), AUTOPLAY_DELAY);
    };

    const pauseForInteraction = () => {
      interactionPaused = true;
      stopAutoplay();
      window.clearTimeout(resumeTimer);
    };

    const resumeAfterInteraction = () => {
      window.clearTimeout(resumeTimer);
      resumeTimer = window.setTimeout(() => {
        if (carousel.matches(':hover') || carousel.matches(':focus-within')) return;
        interactionPaused = false;
        startAutoplay();
      }, RESUME_DELAY);
    };

    const bindArrow = (selector, direction, label) => {
      const arrow = carousel.querySelector(selector);
      if (!arrow || arrow.dataset.jpReviewArrow === 'true') return;
      arrow.dataset.jpReviewArrow = 'true';
      arrow.setAttribute('role', 'button');
      arrow.setAttribute('tabindex', '0');
      arrow.setAttribute('aria-label', label);
      const activate = (event) => {
        if (event.type === 'keydown' && !['Enter', ' '].includes(event.key)) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        pauseForInteraction();
        move(direction);
        resumeAfterInteraction();
      };
      arrow.addEventListener('click', activate, true);
      arrow.addEventListener('keydown', activate, true);
    };

    bindArrow('.jdgm-carousel__left-arrow', -1, italian ? 'Recensione precedente' : 'Previous review');
    bindArrow('.jdgm-carousel__right-arrow', 1, italian ? 'Recensione successiva' : 'Next review');

    carousel.addEventListener('click', (event) => {
      if (!event.target.closest('.jp-review-toggle')) return;
      pauseForInteraction();
      if (!track.querySelector('.jp-review-expanded')) resumeAfterInteraction();
    });
    carousel.addEventListener('mouseenter', pauseForInteraction);
    carousel.addEventListener('mouseleave', resumeAfterInteraction);
    carousel.addEventListener('focusin', pauseForInteraction);
    carousel.addEventListener('focusout', resumeAfterInteraction);
    track.addEventListener('pointerdown', pauseForInteraction, { passive: true });
    track.addEventListener('pointerup', () => {
      resumeAfterInteraction();
      window.setTimeout(() => {
        const card = track.querySelector('.jdgm-carousel-item.jp-review-expanded');
        if (!card) return;
        const viewport = track.getBoundingClientRect();
        const cardBox = card.getBoundingClientRect();
        if (cardBox.right <= viewport.left + 4 || cardBox.left >= viewport.right - 4) setReviewExpanded(card, false);
      }, 450);
    }, { passive: true });
    document.addEventListener('visibilitychange', startAutoplay);
    reducedMotion.addEventListener?.('change', startAutoplay);
    window.addEventListener('resize', () => {
      startAutoplay();
      requestAnimationFrame(() => cards.forEach(syncReviewToggle));
    }, { passive: true });
    document.fonts?.ready.then(() => cards.forEach(syncReviewToggle));
    requestAnimationFrame(startAutoplay);
  };

  const initialize = (root = document) => root.querySelectorAll(SELECTOR).forEach(setupCarousel);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(), { once: true });
  else initialize();

  let queued = false;
  new MutationObserver(() => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => {
      queued = false;
      initialize();
    });
  }).observe(document.documentElement, { childList: true, subtree: true });

  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
